export default __webpack_public_path__ + "static/_CAT3717-c09e6a677c3186c7ceae5dbd0c2a9077.jpg";